define('SageDotCom/Utility/ProductSchema',[
    "jquery"
], function ($) {
    function ProductSchema() { }

    ProductSchema.prototype.init = function init() {
        $(document).ready(function () {

            var $prodCard = $(".sage-product-card-outer");
            if ($prodCard.length > 0) {
                var scriptElement = document.createElement("script");
                scriptElement.type = "application/ld+json";
                
                var $name = ($('meta[name="sage:products"]').attr("content") !== "") ? $('meta[name="sage:products"]').attr("content") : ($("div.navbar-brand").text().trim() !== "") ? $("div.navbar-brand").text().trim() : "" ;
                if ($name === "$name") {
                    $name = ($("div.navbar-brand").text().trim() !== "") ? $("div.navbar-brand").text().trim() : "";
                    console.error("'metadata name incorrect - $name'");
                }
                var $description = $('meta[name="sage:pagedescription"]').attr("content");
                var $priceCurrency = $('meta[name="product:pretax_price:currency"]').attr("content");
                var $price = $(".sage-product-card-price-alt");
                if (!($price && $price.length > 0))
                    $price = $(".main-price-line .price");

                var sellerObj = new Object();
                sellerObj["@type"] = "Organization";
                sellerObj["name"] = "Sage";
              
                if ($prodCard.length === 1) {
                    var price = (($price && $price.length > 0) ? $price.text() : "0.0");
                    var sku = "0000000";
                    var brandObj = new Object();
                    brandObj["@type"] = "Brand";
                    brandObj["name"] = "Sage";
                    var offerObj = new Object();
                    offerObj["@type"] = "Offer";
                    offerObj["url"] = location.toString();
                    offerObj["priceCurrency"] = ($priceCurrency) ? $priceCurrency : "";
                    offerObj["price"] = ((price.indexOf('FREE')) === 0) ? "0.00" : price;
                    offerObj["availability"] = "https://schema.org/OnlineOnly";
                    offerObj["seller"] = sellerObj;
                   
                    scriptElement.text = JSON.stringify({
                        "@context": "http://schema.org",
                        "@type": "Product",
                        "name": $name,
                        "description": $description,
                        "sku": sku,
                        "brand" : brandObj,
                        "offers": offerObj
                    });
                    document.querySelector("head").appendChild(scriptElement);
                }
                if ($prodCard.length > 1) {
                    var $titleArea = $(".sage-product-card-title-area span");
                    var $prodcartTitle = $(".sage-product-card-title");
                    var $prodcartSubTitle = $(".sage-product-card-subtitle");
                    var offersArray = [];

                    $prodCard.each(function (index) {
                        var offerObj = new Object();
                        var price = ($price[index] && $price[index].innerText.trim() !== "") ? $price[index].innerText.trim() : "0.0";
                        var titleArea = ($titleArea[index] && $titleArea[index].innerText.trim() !== "") ? $titleArea[index].innerText.trim() : "";
                        var prodcartTitle = ($prodcartTitle[index] && $prodcartTitle[index].innerText.trim() !== "") ? $prodcartTitle[index].innerText.trim() : "";
                        var prodcartSubTitle = ($prodcartSubTitle[index] && $prodcartSubTitle[index].innerText.trim() !== "") ? $prodcartSubTitle[index].innerText.trim() : "";
                        var sku = (titleArea !== "" && prodcartTitle !== "") ? titleArea + " - " + prodcartTitle : (prodcartTitle !== "" && prodcartSubTitle !== "") ? prodcartSubTitle + " - " + prodcartTitle  : "";
                        if (sku === "") {
                            sku = (titleArea !== "")
                                ? titleArea
                                : (prodcartTitle !== "")
                                ? prodcartTitle
                                : (prodcartSubTitle !== "")
                                ? prodcartSubTitle
                                : "";
                        }
                        offerObj["@type"] = "Offer";
                        offerObj["sku"] = sku;
                        offerObj["url"] = location.toString();
                        offerObj["price"] = ((price.indexOf('FREE')) === 0) ? "0.00" : price; 
                        offerObj["priceCurrency"] = ($priceCurrency) ? $priceCurrency : "";
                        offerObj["availability"] = "https://schema.org/OnlineOnly";
                        offerObj["seller"] = sellerObj;
                        offersArray.push(offerObj);
                        
                    });
                    scriptElement.text = JSON.stringify({
                        "@context": "http://schema.org",
                        "@type": "Product",
                        "name": $name,
                        "description": $description,
                        "offers": offersArray
                    });
                    document.querySelector("head").appendChild(scriptElement);
                }
            }

        });
    }

    return new ProductSchema();
});
